import { render, staticRenderFns } from "./AuthPortalCode.vue?vue&type=template&id=c81894ba&scoped=true"
import script from "./AuthPortalCode.vue?vue&type=script&lang=js"
export * from "./AuthPortalCode.vue?vue&type=script&lang=js"
import style0 from "@pds/core/core.min.css?vue&type=style&index=0&id=c81894ba&prod&scoped=true&lang=css&external"
import style1 from "@pds/typography/typography.min.css?vue&type=style&index=1&id=c81894ba&prod&scoped=true&lang=css&external"
import style2 from "./AuthPortalCode.vue?vue&type=style&index=2&id=c81894ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c81894ba",
  null
  
)

export default component.exports